import { render } from "./whr-project-donation.vue?vue&type=template&id=23c8227e&scoped=true"
import script from "./whr-project-donation.vue?vue&type=script&lang=js"
export * from "./whr-project-donation.vue?vue&type=script&lang=js"

import "./whr-project-donation.vue?vue&type=style&index=0&id=23c8227e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c8227e"]])

export default __exports__